import { render, staticRenderFns } from "./WxQQWebGo.vue?vue&type=template&id=ffeeee24&scoped=true&"
import script from "./WxQQWebGo.vue?vue&type=script&lang=js&"
export * from "./WxQQWebGo.vue?vue&type=script&lang=js&"
import style0 from "./WxQQWebGo.vue?vue&type=style&index=0&id=ffeeee24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffeeee24",
  null
  
)

export default component.exports